import { RemoteUpdateQuestion } from 'data/usecases';
import { makeApiUrlEvaluationCriteriaQuestions } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteUpdateQuestion = (): RemoteUpdateQuestion => {
  return new RemoteUpdateQuestion(
    makeApiUrlEvaluationCriteriaQuestions(),
    makeAxiosHttpClient(),
  );
};
